import { Mutation } from '@apollo/client/react/components';
import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import isEmail from 'validator/lib/isEmail';
import { RECAPTCHA_SITE_KEY } from '../../config';
import { START_PASSWORD_RESET } from '../../helpers/graphql/onboarding';
import CustomSnackbar from '../Dashboard/Notifications/CustomSnackbar';
import JournalField from '../Onboarding/JournalField';

const PasswordResetForm = () => {
  const [email, setEmail] = useState(undefined);
  const [captcha, setCaptcha] = useState(undefined);
  const [isMailValid, setMailValid] = useState(true);

  const handleEmailChange = () => event => {
    setEmail(event.target.value);
    if (event.target.value) setMailValid(isEmail(event.target.value));
  };

  return (
    <>
      <Mutation
        mutation={START_PASSWORD_RESET}
        variables={{
          email,
          captcha,
        }}
      >
        {(startPassWordReset, data) => {
          if (
            data &&
            data.data &&
            data.data.startPassWordReset &&
            data.data.startPassWordReset.success
          ) {
            return (
              <CustomSnackbar
                variant="success"
                message="We just sent you an email to reset your password."
              />
            );
          }
          return (
            <>
              {data && data.data && data.data.startPassWordReset && (
                <CustomSnackbar
                  variant="error"
                  message={`${data.data.startPassWordReset.message}. Reload the page to try again.`}
                />
              )}
              <JournalField
                label="Email"
                id="reset-email"
                type="email"
                name="email"
                autoComplete="email"
                autoFocus
                value={email || ''}
                onChange={handleEmailChange()}
                error={!isMailValid ? 'A valid email is required' : null}
                className="tw-mb-4"
              />
              <div className="tw-mb-4">
                <ReCAPTCHA
                  sitekey={RECAPTCHA_SITE_KEY}
                  onChange={token => setCaptcha(token)}
                />
              </div>
              <button
                type="button"
                onClick={startPassWordReset}
                disabled={!captcha || !email || !isMailValid}
                className="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-border-0 tw-bg-primary-600 tw-px-6 tw-py-3.5 tw-text-base tw-font-semibold tw-text-white tw-shadow-[0_10px_30px_-10px_rgba(0,137,123,0.7)] tw-transition-all tw-duration-200 hover:-tw-translate-y-0.5 hover:tw-bg-primary-700 disabled:tw-cursor-not-allowed disabled:tw-opacity-60"
              >
                Send password mail
                {data.loading && (
                  <span className="tw-h-5 tw-w-5 tw-animate-spin tw-rounded-full tw-border-2 tw-border-solid tw-border-white tw-border-t-transparent" />
                )}
              </button>
            </>
          );
        }}
      </Mutation>
    </>
  );
};

PasswordResetForm.defaultProps = {
  autoFocus: true,
};

export default PasswordResetForm;
